import i18n from "../../../../../../constants/i18n";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import getCorePopUpStore from "../../../../../../stores/core/core-popup-store";
import getKhattabat102Store from "../../../../../../stores/khattabat-stores/102-stores";
import { isPositiveNumber } from "et3-type-guards";
import getKhattabat102GeneralStore from "../../../../../../stores/khattabat-stores/102-stores/general-102-store";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
const ReactivateConversation = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { theme, conversationID } = props;
  const { colors, unitX } = theme;
  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();
  const { exitByMatch, exitByUser } = getKhattabat102Store(conversationID);
  const isOneOTwoConversation = conversationType === "102";
  const shouldShow = isOneOTwoConversation;
  const isConversationExitExists =
    isPositiveNumber(exitByUser.get()) || isPositiveNumber(exitByMatch.get());

  return !shouldShow ? null : (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        backgroundColor: isConversationExitExists
          ? colors.all.green
          : colors.all.gray,
        borderRadius: 36 * unitX,
        cursor: "pointer"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={async () => {
        if (isConversationExitExists) {
          getKhattabat102GeneralStore().setReactivateOneOTwoConversation(
            conversationID
          );
          getCorePopUpStore().openConfirmationPopUps(
            "ONE_O_TWO_CONFIRMATION_POPUP"
          );
        }
      }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get("REACTIVATE")}
        style={{}}
        color={colors.all.white}
      />
    </ET3Div>
  );
});

export default ReactivateConversation;
